export const primaryButtonProps = {
    color: 'secondary',
    class: 'primary--text px-8',
    elevation: 8,
}
